import httpRequest from '@/utils/api'
import type {
  PlatformTutorMonthlyOverviewResponse,
  PlatformTutorSettlementBatchDetailResponse,
  PlatformTutorSettlementBatchListResponse,
  PlatformTutorSettlementConfirmRequest,
  PlatformTutorSettlementConfirmResponse,
  PlatformTutorSettlementPreviewRequest,
  PlatformTutorSettlementPreviewResponse,
  PlatformTutorSettlementRecordListResponse,
  PlatformTutorSettlementStatus,
} from '@/types/admin/platformTutorSettlement'

enum API {
  overview = '/admin/platform-tutor-settlements/overview',
  preview = '/admin/platform-tutor-settlements/preview',
  confirm = '/admin/platform-tutor-settlements/confirm',
  batches = '/admin/platform-tutor-settlements/batches',
  batch = '/admin/platform-tutor-settlements/batches/:batchId',
  records = '/admin/platform-tutor-settlements/records',
}

export const getPlatformTutorSettlementOverviewAPI = (settlementMonth: string) => {
  return httpRequest.get<PlatformTutorMonthlyOverviewResponse>({
    url: API.overview,
    params: { settlementMonth },
  })
}

export const previewPlatformTutorSettlementAPI = (data: PlatformTutorSettlementPreviewRequest) => {
  return httpRequest.post<PlatformTutorSettlementPreviewResponse>({
    url: API.preview,
    data,
  })
}

export const confirmPlatformTutorSettlementAPI = (data: PlatformTutorSettlementConfirmRequest) => {
  return httpRequest.post<PlatformTutorSettlementConfirmResponse>({
    url: API.confirm,
    data,
  })
}

export const getPlatformTutorSettlementBatchesAPI = (params: {
  tutorId?: number | null
  settlementMonth?: string | null
  limit?: number
  offset?: number
}) => {
  return httpRequest.get<PlatformTutorSettlementBatchListResponse>({
    url: API.batches,
    params,
  })
}

export const getPlatformTutorSettlementBatchDetailAPI = (batchId: number) => {
  return httpRequest.get<PlatformTutorSettlementBatchDetailResponse>({
    url: API.batch.replace(':batchId', batchId.toString()),
  })
}

export const getPlatformTutorSettlementRecordsAPI = (params: {
  tutorId?: number | null
  settlementMonth?: string | null
  status?: PlatformTutorSettlementStatus | null
  page?: number
  limit?: number
}) => {
  return httpRequest.get<PlatformTutorSettlementRecordListResponse>({
    url: API.records,
    params,
  })
}
